import { render, staticRenderFns } from "./AlarmsByObject.vue?vue&type=template&id=a3225cca&scoped=true&"
import script from "./AlarmsByObject.vue?vue&type=script&lang=js&"
export * from "./AlarmsByObject.vue?vue&type=script&lang=js&"
import style0 from "./AlarmsByObject.vue?vue&type=style&index=0&id=a3225cca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3225cca",
  null
  
)

export default component.exports